import { ICReportWidget } from '@/pages/funds/ic-report/components/ICReportWidget'
import { DownloadRawDataButtons } from '@/pages/funds/ic-report/components/composites/scenario-analysis-buttons'
import { DiversifiersScenarioChart as DiversifiersScenarioChartNew } from '@/pages/funds/ic-report/components/primitives/charts/DiversifiersScenarioChartNew'
import { BaseICReportPrimitive } from '@/pages/funds/ic-report/components/primitives/types'
import { labels } from '@/pages/funds/ic-report/constants'
import { diversifiers } from '@/react-query/queries/ic-report/hooks'

export type DiversifiersScenarioProps = BaseICReportPrimitive & {}

export const DiversifiersScenario: React.FC<DiversifiersScenarioProps> = () => {
  return (
    <div className="flex items-stretch gap-4">
      {/* <ICReportWidget
        widget={{
          component: DiversifiersScenarioChart,
          query: diversifiers.useHistoricalEvents,
          key: 'diversifiers.historical_events',
          labels: labels.diversifiers.scenario_analysis,
          sidebarTitle: 'sdfsdf',
        }}
      /> */}
      <ICReportWidget
        widgetButtons={[
          <DownloadRawDataButtons
            filePrefix={`diversifiers`}
            query={diversifiers.useHistoricalEventsNew}
          />,
        ]}
        widget={{
          component: DiversifiersScenarioChartNew,
          query: diversifiers.useHistoricalEventsNew,
          key: 'diversifiers.historical_events',
          labels: labels.diversifiers.scenario_analysis,
          sidebarTitle: 'sdfsdf',
        }}
      />
    </div>
  )
}
